var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5556 4.96574C26.5222 5.3963 25.4889 5.74074 24.2833 5.82685C25.4889 5.13796 26.35 4.01852 26.7806 2.72685C25.6611 3.41574 24.4556 3.8463 23.1639 4.10463C22.1306 2.98519 20.6667 2.2963 19.1167 2.2963C16.0167 2.2963 13.4333 4.79352 13.4333 7.97963C13.4333 8.41018 13.5194 8.84074 13.6056 9.2713C8.86944 9.01296 4.73611 6.77407 1.98056 3.32963C1.46389 4.19074 1.20556 5.13796 1.20556 6.1713C1.20556 8.15185 2.23889 9.87407 3.70278 10.9074C2.75556 10.9074 1.89444 10.6491 1.11944 10.2185V10.3046C1.11944 13.0602 3.1 15.2991 5.68333 15.8157C5.16667 15.9018 4.73611 15.988 4.21944 15.988C3.875 15.988 3.53056 15.988 3.18611 15.9019C3.875 18.1407 6.02778 19.7769 8.43889 19.863C6.54444 21.413 4.04722 22.2741 1.37778 22.2741C0.947222 22.2741 0.430556 22.2741 0 22.188C2.49722 23.8241 5.51111 24.6852 8.69722 24.6852C19.1167 24.6852 24.8 16.0741 24.8 8.58241C24.8 8.32407 24.8 8.06574 24.8 7.89352C25.8333 7.11852 26.7806 6.08519 27.5556 4.96574Z",
    fill: "#4699C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.1fd5bd50bf970e1d7c2e6d47f6188cca.svg";
export { ForwardRef as ReactComponent };